import {
  SERVIZI_PLUS_SELECTED_SERVIZIO,
  SERVIZI_PLUS_UNSELECT_ALL,
  SERVIZI_PLUS_UNSELECTED_SERVIZIO,
} from '../../constants/ActionTypes'
import { createBasicCreator } from '../Buy'

export const setSelectedServizio = createBasicCreator(
  SERVIZI_PLUS_SELECTED_SERVIZIO
)
export const unSetSelectedServizio = createBasicCreator(
  SERVIZI_PLUS_UNSELECTED_SERVIZIO
)
export const unSetAllServiziPlus = createBasicCreator(SERVIZI_PLUS_UNSELECT_ALL)
